'use strict';

module.exports = {
    COMPLETED: 'COMPLETED',
    ERROR: 'ERROR',
    /**
     * Yep, one L would be better but we are stuck this was for backwards compatibility reasons.
     */
    CANCELLED: 'CANCELLED',
    IN_PROGRESS: 'IN_PROGRESS'
};